const setState = (key) => (state, val) => {
  // eslint-disable-next-line no-param-reassign
  state[key] = val;
};

export default setState;
